import createTheme from '@mui/material/styles/createTheme';

const defaultTheme = createTheme();

const PALETTE_SECONDARY_MAIN = '#FFFB00'; // Yellow

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFF',
    },
    text: {
      secondary: '#8F8F8F',
      disabled: '#BBB',
    },
    secondary: {
      main: PALETTE_SECONDARY_MAIN,
      dark: '#222222',
      light: '#484848',
    },
    background: {
      default: '#000',
      //paper: "#111",
    },
    success: {
      main: '#449E48',
      dark: '#516752',
      // light: '#92BF94',
      contrastText: '#92BF94',
    },
    error: {
      main: '#FF6767',
      dark: '#593333',
      // light: '#FFC0C0',
      contrastText: '#FFC0C0',
    },
    warning: {
      main: '#E88A00',
      dark: '#7A6240',
      // light: '#E3C8A0',
      contrastText: '#E3C8A0',
    },
    info: {
      main: '#1E88DC',
      dark: '#476277',
      light: '#121212',
      // light: '#E3C8A0',
      contrastText: '#7295B2',
    },
  },
  shape: {
    borderRadius: 2,
  },
  spacing: 8,
  typography: {
    fontFamily: 'Haas Grot Text R Web, Haas Grot Disp R Web',
    // fontSize: 12,
    h1: {
      fontFamily: 'Haas Grot Disp R Web',
      fontSize: 38,
      lineHeight: '41px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 30,
        lineHeight: '33px',
      },
    },
    h2: {
      fontFamily: 'Haas Grot Disp R Web',
      fontSize: 38,
      lineHeight: '41px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 19,
        lineHeight: '22px',
      },
    },
    h3: {
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 19,
      lineHeight: '22px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 16,
        lineHeight: '19px',
      },
    },
    h4: {
      fontFamily: 'Haas Grot Disp R Web',
      fontSize: 70,
      lineHeight: '73px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 40,
        lineHeight: '43px',
      },
    },
    h5: {
      // Used by CardMaster - do not alter
      fontFamily: 'Haas Grot Disp R Web',
      fontSize: 50,
      lineHeight: '43px',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    h6: {
      // Body - only bolder
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 19,
      lineHeight: '22px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 16,
        lineHeight: '19px',
      },
    },
    subtitle1: {
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 14,
      lineHeight: '16px',
      fontWeight: 400,
      letterSpacing: '0.01em',
    },
    subtitle2: {
      // Figma Desktop/Body Bold & Mobile/Body Bold
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 19,
      lineHeight: '22px',
      fontWeight: 500,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 14,
        lineHeight: '16px',
      },
    },
    body1: {
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 19,
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 16,
        lineHeight: '19px',
      },
    },
    body2: {
      fontSize: 19,
      lineHeight: '22px',
      fontWeight: 400,
      fontFamily: 'Haas Grot Text R Web',
      letterSpacing: '0.01em',
      '@media (max-width: 959.95px)': {
        fontSize: 14,
        lineHeight: '16px',
      },
    },
    button: {
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 14,
      lineHeight: '19px',
      fontWeight: 500,
      letterSpacing: '0.01em',
    },
    caption: {
      // Matches: Universal Input Text / Label H2 / Haas Grot Text R (55 Roman) from Figma
      fontFamily: 'Haas Grot Text R Web',
      fontSize: 9,
      lineHeight: '12px',
      fontWeight: 400,
      letterSpacing: '0.01em',
    },
    overline: {
      color: 'red',
      textDecoration: 'line-through',
    },
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#222222',
          fontFamily: 'Haas Grot Text R Web',
          fontSize: 14,
          lineHeight: '16px',
          fontWeight: 400,
          letterSpacing: '0.01em',
          padding: '8px 16px',
          borderRadius: 5,
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
        arrow: {
          color: '#222222',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        // Ok this is amazing - you can override default props now!
        underline: 'hover',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'initial',
          [defaultTheme.breakpoints.up('sm')]: {
            whiteSpace: 'nowrap',
          },
        },
        text: {
          textDecoration: 'underline',
          '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          },
        },
        contained: {
          borderRadius: 25,
        },
        outlined: {
          borderRadius: 25,
        },
        sizeSmall: {
          minHeight: 35,
          '@media (max-width: 600px)': {
            minHeight: 32,
          },
        },
        sizeMedium: {
          minHeight: 40,
        },
        sizeLarge: {
          fontSize: 19,
          lineHeight: '24px',
        },
        outlinedSizeSmall: {
          minWidth: 130,
          '@media (max-width: 600px)': {
            minHeight: 35,
          },
        },
        outlinedSizeLarge: {
          padding: '11px 24px',
          minWidth: 220,
          '@media (max-width: 600px)': {
            minWidth: 183,
          },
        },
        outlinedSecondary: {
          // NOTE: We're wrapping up a couple of last minute changes before doing a code freeze and launching
          // the site. The outline button style gets lost in the background. The client has requested the button
          // is changed to always use solid yellow background colour.
          // https://iegroup.atlassian.net/browse/TCN-722
          //
          // The correct way to approach this task would be to introduce a new button style with an appropriate
          // name. Then update all buttons to use the correct button style. However I don't think we have enough
          // time for that today. Therefore I've updated the "outlined" button style to have a solid colour background.
          // Perhaps we can update this code during the upcoming maintainence period.
          backgroundColor: '#FFFB00',
          color: 'black',
          padding: '3px 16px',
          '&:hover': {
            backgroundColor: '#BFBD30',
            borderColor: '#BFBD30',
            color: 'black',
          },
          '&.Mui-disabled': {
            color: 'black',
            borderColor: 'rgb(178, 175, 0)',
            backgroundColor: 'rgb(178, 175, 0)',
          },
        },
        outlinedPrimary: {
          '&:hover': {
            backgroundColor: '#FFFFFF',
            color: 'black',
          },
        },
        textSizeLarge: {
          textDecoration: 'none',
          borderRadius: 0,
          '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'transparent',
            '&:after': {
              content: "''",
              height: 1,
              backgroundColor: PALETTE_SECONDARY_MAIN,
              position: 'absolute',
              left: 11,
              right: 11,
              boxSizing: 'border-box',
              bottom: 6,
            },
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        colorSecondary: {
          backgroundColor: '#585858',
          borderRadius: 12,
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          background: '#585858',
          borderRadius: 64,
          padding: 2,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'initial',
          minWidth: 'min(158px, 30vw)',
          padding: '12px max(4px, min(2vw, 15px))',
          borderRadius: 64,
          border: 0,
          fontSize: 14,
          fontWeight: 500,
          '&.Mui-selected': {
            background: '#ffffff',
            color: '#000000',
            '&.MuiToggleButtonGroup-grouped': {
              borderRadius: 64,
            },
            '&:hover': {
              background: '#ffffff',
            },
          },
          '&:hover': {
            background: 'transparent',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        // root: {
        //   '&.Mui-focused': {
        //     backgroundColor: 'transparent',
        //     color: 'red',
        //   },
        // },
        // input: {
        //   '&.Mui-focused': {
        //     backgroundColor: 'transparent',
        //     color: 'blue',
        //   },
        // },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {},
        input: {
          paddingLeft: 5,
        },
        underline: {
          '&:before': {
            borderBottom: '1px solid #222222',
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        required: false,
      },
      styleOverrides: {
        root: {
          color: 'white',
          paddingLeft: 5,
        },
        shrink: {
          transform: 'translate(0,0) scale(0.6)',
          paddingLeft: 9,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          paddingLeft: 5,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#FFFB00',
        },
        iconOpen: {
          right: 0,
          transform: 'rotate(180deg)',
        },
        root: {},
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          '& .MuiListItem-root:hover': {
            color: '#FFFB00',
            background: '#585858',
          },
          maxHeight: 150,
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          backgroundColor: '#FFFB00',
        },
      },
    },
    //calendar - date picker
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#222222',
        },
      },
    },
    // @ts-ignore
    MuiPickersDay: {
      styleOverrides: {
        root: {
          background: '#222222',
          fontSize: 16,
          '&.Mui-selected': {
            backgroundColor: '#585858',
            border: '1px solid #FFFB00',
            color: '#FFFFFF',
          },
          // [defaultTheme.breakpoints.up('sm')]: {
          //   width: 50,
          //   height: 50,
          // },
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          // [defaultTheme.breakpoints.up('sm')]: {
          //   width: 400,
          // },
        },
      },
    },
    PrivatePickersCalendar: {
      styleOverrides: {
        weekDayLabel: {
          [defaultTheme.breakpoints.up('sm')]: {
            width: 50,
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 2550,
    },
  },
});

export default theme;
